import request,{http} from '@/utils/request'

export function getPurchaseAnnouncementPage (data) {
  return request({
    url: '/purchaseAnnouncement/getPurchaseAnnouncementPage',
    method: 'post',
    data: data
  })
}
// 登录
export function login (data) {
  return request({
    url: '/user/login',
    method: 'post',
    data: data
  })
}
// 获取方式
export function getModeList () {
  return request({
    url: '/projectInformation/getModeList',
    method: 'get'
  })
}
// 获取类型
export function getTypeList () {
  return request({
    url: '/projectInformation/getTypeList',
    method: 'get'
  })
}
// 获取项目信息列表-分页
export function getProjectInfo (data) {
  return request({
    url: '/projectInformation/getInvitationPurchaseAnnouncementPage',
    method: 'post',
    data: data
  })
}
// 获取项目信息详情
export function getProjectInfoDetail (data) {
  return request({
    url: '/projectInformation/getProjectInformationDetail',
    method: 'post',
    data: {id: data}
  })
}
// 报名申请
export function participatoryUnitApply (data) {
  return request({
    url: '/projectInformation/participatoryUnitApply',
    method: 'post',
    data: data
  })
}
// 投标材料编辑
export function updateParticipatoryUnitFile (data) {
  return request({
    url: '/myProject/updateParticipatoryUnitFile',
    method: 'post',
    data: data
  })
}

// 文件地址
export function getFileUrl (data) {
  return http({
    url: '/common/getFileUrl',
    method: 'post',
    data: { fileId: data }
  })
}
// 项目文件阅读
export function addProjectFileReader (data) {
  return http({
    url: '/projectInformation/addProjectFileReader',
    method: 'post',
    data: { mid: data }
  })
}
// 获取我的项目列表-分页
export function getMyProjectPage (data) {
  return request({
    url: '/myProject/getMyProjectPage',
    method: 'post',
    data: data
  })
}

// 文件上传返回文件id
export function fileUploadResultFid (data) {
  return request({
    url: '/common/fileUploadResultFid',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: data
  })
}
// 获取采购公告详情
export function getPurchaseAnnouncementDetail (data) {
  return request({
    url: '/purchaseAnnouncement/getPurchaseAnnouncementDetail',
    method: 'post',
    data: {id: data}
  })
}
// 上传文件-注册
export function uploadFile (data) {
  return request({
    url: '/common/uploadFile',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: data
  })
}
// 注册账号
export function userRegistration (data) {
  return request({
    url: '/user/userRegistration',
    method: 'post',
    data: data
  })
}
// 获取类型
export function getTypesList () {
  return request({
    url: '/common/getRegisterTypeLists',
    method: 'get'
 })
}

// 验证账号
export function isRegister (data) {
  return request({
    url: '/user/isRegister',
    method: 'post',
    data: {unitName:data}
  })
}
// 忘记密码-链接
export function forgetPwd (data) {
  return request({
    url: '/user/forgetPwd',
    method: 'post',
    data: {unitName:data}
  })
}

// 忘记密码-修改
export function forgetPwdUpdate (data) {
  return request({
    url: '/user/forgetPwdUpdate',
    method: 'post',
    data: data
  })
}
// 修改密码
export function changepwd (data) {
  return request({
    url: '/user/change/pwd',
    method: 'post',
    data: data
  })
}